import { TrackedLink } from "@components/analytics/TrackedLink";
import Breadcrumbs from "@components/Breadcrumbs";
import { ImgSrc } from "@config/image";
import { Container, Row, Col } from "react-grid-system";

const Notecard = () => (
  <>
    <Container className="landingGridContainer">
      <Row>
        <Col md={12} lg={8}>
          <Breadcrumbs
            links={[
              { name: "Docs", url: "/docs" },
              { name: "Notecard", url: "/notecard" },
            ]}
          />
          <h1>Notecard</h1>
          <p>
            The hub for documentation on Notecard. In-depth information about
            how the Notecard works, and how to configure the Notecard for your
            projects.
          </p>
        </Col>
      </Row>

      <hr />

      <Row>
        <Col>
          <h2>Notecard Walkthrough</h2>
          <p>
            A comprehensive walkthrough of the features and capabilities of the
            Notecard.
          </p>

          <div className="gridLinks">
            <h4>In this section</h4>
            <div className="three-column">
              <TrackedLink href="/notecard/notecard-walkthrough/overview">
                Notecard Overview
              </TrackedLink>
              <TrackedLink href="/notecard/notecard-walkthrough/notecard-product-family">
                Notecard Product Family
              </TrackedLink>
              <TrackedLink href="/notecard/notecard-walkthrough/notecard-requests-and-responses">
                Notecard Requests & Responses
              </TrackedLink>
              <TrackedLink href="/notecard/notecard-walkthrough/json-fundamentals">
                JSON Fundamentals
              </TrackedLink>
              <TrackedLink href="/notecard/notecard-walkthrough/notecard-interfaces">
                Notecard Interfaces
              </TrackedLink>
              <TrackedLink href="/notecard/notecard-walkthrough/essential-requests">
                Essential Requests
              </TrackedLink>
              <TrackedLink href="/notecard/notecard-walkthrough/time-and-location-requests">
                Time & Location Requests
              </TrackedLink>
              <TrackedLink href="/notecard/notecard-walkthrough/inbound-requests-and-shared-data">
                Inbound Requests & Shared Data
              </TrackedLink>
              <TrackedLink href="/notecard/notecard-walkthrough/web-transactions">
                Web Transactions
              </TrackedLink>
              <TrackedLink href="/notecard/notecard-walkthrough/low-power-design">
                Low Power Design
              </TrackedLink>
              <TrackedLink href="/notecard/notecard-walkthrough/low-bandwidth-design">
                Low Bandwidth Design
              </TrackedLink>
              <TrackedLink href="/notecard/notecard-walkthrough/working-with-the-notecard-aux-pins">
                Working with the Notecard AUX Pins
              </TrackedLink>
              <TrackedLink href="/notecard/notecard-walkthrough/updating-notecard-firmware">
                Updating Notecard Firmware
              </TrackedLink>
              <TrackedLink href="/notecard/notecard-walkthrough/advanced-notecard-configuration">
                Advanced Notecard Configuration
              </TrackedLink>
              <TrackedLink href="/notecard/notecard-walkthrough/notecard-error-and-status-codes">
                Notecard Error and Status Codes
              </TrackedLink>
              <TrackedLink href="/notecard/notecard-walkthrough/notecard-certifications">
                Notecard Certifications
              </TrackedLink>
            </div>
          </div>
        </Col>
      </Row>

      <hr />
      <h2>Notecard Resources</h2>

      <Row>
        <Col>
          <div className="landing-page-link-list">
            <div>
              <img
                alt=""
                src={ImgSrc("/images/icons/docs/notecard-solutions.svg")}
              />
              <h4>Notecard API Reference</h4>
              <p>
                Complete listing of all the requests you can send to the
                Notecard in host firmware.
              </p>
              <TrackedLink
                href="/api-reference/notecard-api"
                className="landingLink"
              >
                Visit API reference
              </TrackedLink>
            </div>

            <div>
              <img
                alt=""
                src={ImgSrc("/images/icons/docs/library-books.svg")}
              />
              <h4>Notecard Guides</h4>
              <p>
                A series of in-depth guides to help you use different features
                of the Notecard.
              </p>
              <TrackedLink
                href="/guides-and-tutorials/notecard-guides"
                className="landingLink"
              >
                Browse guides
              </TrackedLink>
            </div>

            <div>
              <img
                alt=""
                src={ImgSrc("/images/icons/docs/firmware-libraries.svg")}
              />
              <h4>Notecard Firmware Releases</h4>
              <p>
                A listing of all Notecard firmware versions, with instructions
                on how to update your devices.
              </p>
              <TrackedLink
                href="/notecard/notecard-firmware-releases"
                className="landingLink"
              >
                Read update guide
              </TrackedLink>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  </>
);

export default Notecard;
